import { render, staticRenderFns } from "./SendUpsertRegi.vue?vue&type=template&id=06b519c8&scoped=true&"
import script from "./SendUpsertRegi.vue?vue&type=script&lang=js&"
export * from "./SendUpsertRegi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b519c8",
  null
  
)

export default component.exports